export default "__VITE_ASSET__71ac7bbc__"